import { type FC } from 'react';
import type { ViewOptionsController } from './ViewOptionsController';
import { observer } from 'mobx-react';
import { ViewOptionsObject } from './ViewOptionsObject';
import type { ViewOption, ViewOptionsStruct } from '@/engine/app/interfaces';

export const ViewOptionsContent: FC<{
  controller: ViewOptionsController;
  items: ViewOptionsStruct | undefined;
  disabledVisibility?: boolean;
}> = observer(({ controller, items, disabledVisibility }) =>
  items?.map((item, index) => (
    <ViewOptionsObject
      key={index}
      controller={controller}
      viewOption={item as ViewOption}
      disabledVisibility={disabledVisibility}
    />
  ))
);
